import pluginPkg from '../../package.json';

const pluginId = pluginPkg.strapi.name;

export const PLUGIN_ID = pluginId;
export const PLUGIN_API_PREFIX = `/${pluginId}`;

export default pluginId;
